import { makeCRUDSlice } from '@redux/crudCreator';
import {
  MODEL_NAME,
  cancelOrder,
  confirmOrder,
  editDeliveryInformation,
  editInvoiceInformation,
  ordersActions,
} from './actions';
import _, { omit, pick } from 'lodash';
import { PRIMARY_KEY } from '@redux/crudCreator/dataProvider';

export const editInformationSuccess = (
  state,
  { payload: { data, options } },
) => {
  state.loading = false;
  state.error = null;
  if (!options?.skipSave) {
    state.data[data[PRIMARY_KEY]] = {
      ...state.data[data[PRIMARY_KEY]],
      ...data,
    };
    state.currentData = { ...state.currentData, ...data };
  }

  if (options?.hasGetAllAfterEdit) {
    state.ids = _.xor(state.ids, [data[PRIMARY_KEY]]);
  }

  state.rollbackData = omit(state.rollbackData, [data.id]);
  state.itemLoadings = { ...state.itemLoadings, [data[PRIMARY_KEY]]: false };
};

export const editInformationFailure = (state, { payload: { data } }) => {
  state.loading = false;
  state.error = data;
  state.data = {
    ...state.data,
    [data[PRIMARY_KEY]]: state.rollbackData[data[PRIMARY_KEY]],
  };
  state.rollbackData = omit(state.rollbackData, [data.id]);
  state.itemLoadings = { ...state.itemLoadings, [data[PRIMARY_KEY]]: false };
};

const slice = makeCRUDSlice(MODEL_NAME, ordersActions, {
  [cancelOrder.pending as any]: (state) => {
    state.loading = true;
    return state;
  },
  [cancelOrder.fulfilled as any]: (state, { payload }) => {
    state.loading = false;
    state.ids = state.ids.filter((e) => e !== payload.id);
    state.total = state.total - 1;
    state.currentData = {
      ...state.currentData,
      ...pick(payload, [
        'partner',
        'partnerId',
        'location',
        'locationId',
        'orderNoErp',
        'customerOrderId',
        'ghnOrderCode',
        'status',
        'statusOms',
        'reason',
        'cancelReason',
        'cancelNote',
      ]),
    };
    return state;
  },
  [cancelOrder.rejected as any]: (state) => {
    state.loading = false;
    return state;
  },
  [confirmOrder.pending as any]: (state) => {
    state.loading = true;
    return state;
  },
  [confirmOrder.fulfilled as any]: (state, { payload }) => {
    state.loading = false;
    state.currentData = {
      ...state.currentData,
      ...pick(payload, [
        'partner',
        'partnerId',
        'location',
        'locationId',
        'orderNoErp',
        'customerOrderId',
        'ghnOrderCode',
        'status',
        'statusOms',
      ]),
    };
    return state;
  },
  [confirmOrder.rejected as any]: (state) => {
    state.loading = false;
    return state;
  },
  [editInvoiceInformation.fulfilled as any]: editInformationSuccess,
  [editInvoiceInformation.rejected as any]: editInformationFailure,
  [editDeliveryInformation.fulfilled as any]: editInformationSuccess,
  [editDeliveryInformation.rejected as any]: editInformationFailure,
});

export default slice.reducer;
